import "./Marquee.css";
import { useTranslation } from "react-i18next";

const Marquee = () => {

  const { t } = useTranslation();

  return (
    <div className="marquee-wrapper">
      <div className="marquee-track">

        <span>
          {t("marquee_text")}
        </span>

        {/* duplicate for seamless loop */}
        <span>
          {t("marquee_text")}
        </span>

      </div>
    </div>
  );
};

export default Marquee;